import { render, staticRenderFns } from "./DraggableDialog.vue?vue&type=template&id=3e2ab20e&scoped=true"
import script from "./DraggableDialog.vue?vue&type=script&lang=js"
export * from "./DraggableDialog.vue?vue&type=script&lang=js"
import style0 from "./DraggableDialog.vue?vue&type=style&index=0&id=3e2ab20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ab20e",
  null
  
)

export default component.exports